import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import SmartFarmLogo from "../../components/common/SmartFarmLogo";

const Terms = () => {
    const [local, setLocal] = useState(localStorage.getItem("local") || "en");
    const { t, i18n } = useTranslation();

    const changeLanguageHandler = (e) => {
        const languageValue = e.target.value
        i18n.changeLanguage(languageValue);
        localStorage.setItem("local", languageValue)
        setLocal(languageValue)
    }

    return (
        <main className="auth-page auth-legal-page">
            <div className="auth-legal-shell">
                <header className="auth-legal-header">
                    <Link to="/sign-up" className="auth-back-link">
                        <i className="fas fa-arrow-left" aria-hidden="true" /> {t('Go_Back', 'Retour')}
                    </Link>
                    <SmartFarmLogo className="auth-legal-logo" />
                    <select
                        value={local}
                        className="auth-legal-lang"
                        aria-label={t('language', 'Langue')}
                        onChange={changeLanguageHandler}
                    >
                        <option value="en">EN</option>
                        <option value="fr">FR</option>
                    </select>
                </header>

                <div className="auth-legal-body">
                    <h1>{t('termes_conditions')}</h1>
                    <p>{t('Terms')}</p>
                </div>
            </div>
        </main>
    )
}

export default Terms
